module.exports = __webpack_public_path__ + "6d3c2892f9da3839664f1c9b1d7defdc.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-6@2x.png
// module id = 532
// module chunks = 0